import React, { useEffect, useState, useRef } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { replaceUrlParam } from "../../common/utils";

import {
  fetchCategories,
  filterCategories,
  fetchMoreCategories,
  getFullList,
  fetchCategoriesTree,
  selectCategories,
  fetchCategoryByID,
} from "./categoriesSlice";

import Grid from "@material-ui/core/Grid";
import CategoriesList from "./CategoriesList";

const useStyles = makeStyles((theme) => ({
  progress: {
    margin: theme.spacing(2),
  },
}));

export default function CategoriesContainer(props) {
  let jwtToken = localStorage.getItem("coreToken");

  const dispatch = useDispatch();
  const classes = useStyles();
  const [ready, setReady] = useState(false);

  const {
    loading,
    categoriesFilter,
    categoriesList,
    lastQuery,
    categoriesAmount,
  } = useSelector(selectCategories);

  const [statusNames, setStatusNames] = useState([]);
  const [statusIDs, setStatusIDs] = useState([]);
  const [statusList, setStatusList] = useState([
    { id: 1, value: "Active", name: "Active" },
    { id: 2, value: "Inactive", name: "Inactive" },
    { id: 3, value: "Deleted", name: "Deleted" },
    { id: 4, value: "Unavailable", name: "Unavailable" },
  ]);

  const [numberShown, setNumberShown] = useState(25);
  const [moreProducts, setMoreProducts] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [sortProperty, setSortProperty] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");

  const firstUpdateCat = useRef(true);

  const handleStatusChange = (event) => {
    let idsArr = [];
    event.target.value.forEach((selected) => {
      let selectedStatus = statusList.filter(
        (status) => status.name === selected
      );
      selectedStatus[0] && idsArr.push(selectedStatus[0].id);
    });

    setStatusNames(event.target.value);
    setStatusIDs(idsArr);
  };

  if (loading === "loaded" && !ready) {
    setReady(true);
  }

  useEffect(() => {
    if (!categoriesList.length) {
      dispatch(
        fetchCategories({
          token: jwtToken,
          query: `?limit=100`,
        })
      );
    }
  }, []);

  useEffect(() => {
    console.log("fetching next 100 categories");
    if (
      categoriesList.length &&
      categoriesList.length != categoriesAmount &&
      firstUpdateCat.current
    ) {
      let searchQuery = "?limit=100";
      searchQuery = replaceUrlParam(searchQuery, "limit", 100);
      dispatch(
        getFullList({
          token: jwtToken,
          offset: categoriesList.length,
          query: searchQuery,
          targetLength: categoriesAmount,
        })
      );
      firstUpdateCat.current = false;
    }

    console.log("categoriesList", categoriesList);
  }, [categoriesList.length]);

  // useEffect(() => {
  //   let searchQuery = lastQuery ? lastQuery : "";

  //   if (rowsPerPage) {
  //     searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
  //   }
  //   dispatch(
  //     fetchCategories({
  //       token: jwtToken,
  //       query: lastQuery ? searchQuery : `?limit=${rowsPerPage}`,
  //     })
  //   );

  //   setNumberShown(rowsPerPage);
  // }, [dispatch, rowsPerPage]);

  // const getFullListTrigger = () => {
  //   let searchQuery = lastQuery ? lastQuery : "";
  //   searchQuery = replaceUrlParam(searchQuery, "limit", 100);

  //   dispatch(
  //     getFullList({
  //       token: jwtToken,
  //       offset:
  //         rowsPerPage > categoriesList.length
  //           ? rowsPerPage
  //           : categoriesList.length,
  //       query: searchQuery,
  //       targetLength: categoriesAmount,
  //     })
  //   );
  // };

  const handleMore = (e, page) => {
    if (page < currentPage) {
      setCurrentPage(page);
      setNumberShown((page + 1) * rowsPerPage);
    } else {
      let expectedLen = (page + 1) * rowsPerPage;
      if (
        categoriesList.length < categoriesAmount &&
        categoriesList.length < expectedLen
      ) {
        dispatch(
          fetchMoreCategories({
            token: jwtToken,
            query: lastQuery,
            offset: numberShown,
          })
        );
      } else if (categoriesList.length == categoriesAmount) {
        setMoreProducts(false);
      }
      setCurrentPage(currentPage + 1);
      setNumberShown((currentPage + 2) * rowsPerPage);
    }

    console.log("categoriesList", categoriesList);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = sortProperty === property && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortProperty(property);
    switch (property) {
      case "updatedAt":
        property = "updated_at";
        break;
      case "createdAt":
        property = "created_at";
        break;
      case "statusID":
        property = "status_id";
        break;
      case "supplierName":
        property = "supplier_name";
        break;
      case "brandName":
        property = "brand_name";
        break;
      case "rrp":
        property = "rrp_margin";
        break;
      case "costPrice":
        property = "cost_price";
        break;
      case "sellingPrice":
        property = "selling_price";
        break;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (property) {
      searchQuery = replaceUrlParam(searchQuery, "order_by", property);
    }
    searchQuery = replaceUrlParam(searchQuery, "sort", isAsc ? "desc" : "asc");
    searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);

    dispatch(
      fetchCategories({
        token: jwtToken,
        query: searchQuery,
      })
    );
  };

  const handleSearch = () => {
    let searchQuery = lastQuery ? lastQuery : "";

    if (statusIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "statuses",
        statusIDs.join(",")
      );
    }

    if (searchTerm) {
      searchQuery = replaceUrlParam(searchQuery, "name", searchTerm);
    }

    console.log("searchQuery", searchQuery);
    dispatch(
      fetchCategories({
        query: searchQuery,
        token: jwtToken,
      })
    );
    setCurrentPage(0);
  };

  const handleClear = () => {
    setStatusNames([]);
    setStatusIDs([]);
    setSearchTerm("");
    setSortDirection(null);
    setSortProperty(null);

    dispatch(
      fetchCategories({
        token: jwtToken,
        query: `?limit=${rowsPerPage}`,
      })
    );
    setCurrentPage(0);
  };

  const handleEditClick = (id) => {
    dispatch(
      fetchCategoryByID({
        id: id,
        token: jwtToken,
      })
    );
  };


  useEffect(() => {
    dispatch(
      fetchCategoriesTree({
        token: jwtToken,
      })
    );
  }, []);

  const selectNames = ["status"];

  if (loading === "loaded" && !ready) {
    setReady(true);
  }

  const headCells = [
    {
      id: "name",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Name",
      long: true,
      sortable: true,
    },

    {
      id: "parentID",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Parent List",
      long: true,
    },

    {
      id: "createdAt",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Created Date",
      long: false,
      sortable: true,
    },
    {
      id: "updatedAt",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Last Updated",
      long: false,
      sortable: true,
    },
    {
      id: "statusID",
      checked: true,
      numeric: false,
      sortable: true,
      disablePadding: false,
      label: "Status",
      long: false,
    },
  ];
  const [rowList, setRowList] = useState([...headCells]);

  let content;
  if (loading === "loading") {
    content = (
      <CircularProgress className={classes.progress} color="secondary" />
    );
  } else if (loading === "loaded") {
    content = (
      <CategoriesList
        data={categoriesList}
        handleStatusChange={handleStatusChange}
        statusNames={statusNames}
        statusList={statusList}
        handleSearch={handleSearch}
        handleClear={handleClear}
        handleEditClick={handleEditClick}
        selectNames={selectNames}
        // checked={checked}
        // names={names}
        // setNames={setNames}
        // handleToggle={handleToggle}
        setSearchTerm={setSearchTerm}
        searchTerm={searchTerm}
        rowList={rowList}
        setRowList={setRowList}
        headCells={headCells}
        productsAmount={categoriesAmount}
        handleMore={handleMore}
        page={currentPage}
        setPage={setCurrentPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        // getFullList={getFullListTrigger}
      />
    );
  }
  // else if (loading === 'error') {
  //   content = <Error error={{message: 'Something went wrong'}} />;
  // }

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ height: "100%" }}
    >
      {content}
    </Grid>
  );
}
